import { RESET, TAX_RATE } from '../types';

import { TaxRate } from '@/api/api';

// values should be falsy
// use null over an empty array or object
// so that we can check them directly within the if conditions
// to find out if we have already fetched the data or not
export const state = () => ({
  taxRate: {
    value: 0,
    error: '',
  },
});

export const getters = {
  [TAX_RATE]({ taxRate }) {
    return taxRate;
  },
};

/* eslint-disable no-param-reassign */
export const mutations = {
  [TAX_RATE](stateObj, taxRate) {
    stateObj.taxRate = taxRate;
  },

  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },
};

export const actions = {
  [TAX_RATE]({ commit }) {
    return TaxRate.get()
      .then(({ body: { tax_rate: tax } }) => {
        commit(TAX_RATE, {
          value: tax,
          error: '',
        });
      })
      .catch(({ body: { message = '' } = {} }) => {
        commit(TAX_RATE, {
          value: 0,
          error: message,
        });
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
